// How a write button reads after the request comes back.
//
// A dry-run is not a success. The door and the write tools return `written`
// for exactly this reason — `created` / `outcome: written` with nothing in
// Salesforce was being read as a creation.

import type { WriteActionResult } from '../api/types';

export function writeOutcomeLine(result: WriteActionResult, verb: string): string {
  if (result.outcome === 'requested') {
    return result.message
      || 'Requested — waiting for approval.';
  }
  if (result.written) {
    return result.message || `${verb} — Salesforce updated.`;
  }
  if (result.outcome === 'dry_run' || result.guard_mode === 'off') {
    return result.message
      || `Not written — SCOUT_WRITES is off. Would ${verb.toLowerCase()} ${result.domain}.`;
  }
  if (result.outcome === 'refused') {
    return result.message || result.reason || `${verb} was refused.`;
  }
  if (result.outcome === 'noop') {
    return result.message || `Nothing to do.`;
  }
  return result.message || `${verb} finished without a write.`;
}

export function writeOutcomeTone(result: WriteActionResult): 'ok' | 'warn' | 'bad' {
  if (result.outcome === 'requested') return 'ok';
  if (result.written) return 'ok';
  if (result.outcome === 'refused') return 'bad';
  return 'warn';
}
